import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import ReactECharts from "echarts-for-react";
import { getRegionalanalyseResult } from "../../selectors/widget.js";
import Block from "../Block";
import Select from "react-select";
import { round } from "lodash";

const Graph = ({ module, regionIds }) => {
  const { name, dataset, leftDropDown, rightDropDown, municipality, cityIndex, filter, nameField, series } = module;
  const apiResult = useSelector((state) => getRegionalanalyseResult(state, dataset));
  const [mergedOptions, setMergedOptions] = useState(null);

  const [leftDropDownOptions, setLeftDropDownOptions] = useState(null);
  const [selectedLeftValue, setSelectedLeftValue] = useState(null);

  const [selectedRightValue, setSelectedRightValue] = useState(null);

  const [apiDataset, setApiDataset] = useState(null);
  const [filteredDataset, setFilteredDataset] = useState(null);

  useEffect(() => {
    if (apiResult) {
      let result = JSON.parse(apiResult);
      let ids = regionIds.map((item) => item.nr);
      let filtered = result.response.filter((item) => ids.includes(item.nr));
      setApiDataset(filtered);
    }
  }, [apiResult, regionIds, name]);

  useEffect(() => {
    if (apiDataset && leftDropDown) {
      if (leftDropDown === "year") {
        const unique = [...new Set(apiDataset.map((item) => item.aar))];
        let sorted = unique.sort((a, b) => (a < b ? 1 : -1));
        let totaltRange = null;
        let filtered = sorted.filter((item) => {
          if (!item) {
            return false;
          }
          if (item.length > 4) {
            totaltRange = item;
            return false;
          }
          return true;
        });
        if (totaltRange) {
          filtered.unshift(totaltRange);
        }
        let parsed = parseOptions(filtered);
        setLeftDropDownOptions(parsed);
      }
    }
    if (apiDataset && !leftDropDown) {
      setLeftDropDownOptions(null);
      setSelectedLeftValue(null);
    }
  }, [apiDataset, leftDropDown]);

  useEffect(() => {
    if (apiDataset && !rightDropDown) {
      setSelectedRightValue(null);
    }
  }, [apiDataset, rightDropDown]);

  useEffect(() => {
    if (rightDropDown && !selectedRightValue) {
      setSelectedRightValue(rightDropDown[0]);
    }
  }, [rightDropDown, selectedRightValue]);

  useEffect(() => {
    if (filteredDataset) {
      let data = filteredDataset;
      let seriesData = series.map((item) => {
        let obj = {
          name: item.label,
          type: "bar",
          stack: "total",
          data: data.map((i) => round(i[item.value] * 100, 2)),
          emphasis: {
            focus: "series",
          },
        };
        return obj;
      });
      if (filter) {
        let filtered = filterDataset(filter, data, cityIndex);
        data = filtered;
      }

      let labels = data.map((item) => {
        let municipalityArray = municipality.split(",");
        let cleanedArray = municipalityArray.map((item) => parseInt(item.trim())).filter(Boolean);
        let boldIds = [cleanedArray, cityIndex, 12001, 0];
        if (nameField) {
          if (item[nameField]) {
            return { value: item[nameField] };
          }
        }

        if (boldIds.includes(item.nr)) {
          return {
            value: item.navn,
            textStyle: { fontWeight: "bolder", color: "black", fontSize: "15" },
          };
        }
        return { value: item.navn };
      });
      let nObj = null;

      nObj = {
        ...JSON.parse(options),
        tooltip: {
          trigger: "item",
          formatter: "{a} : {c}%",
        },
        yAxis: {
          type: "category",
          data: labels,
        },
        xAxis: {
          type: "value",
        },
        series: seriesData,
      };

      nObj.xAxis.axisLabel = {
        formatter: function (value) {
          return value + "%";
        },
      };

      setMergedOptions(nObj);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filteredDataset, selectedRightValue, name]);

  useEffect(() => {
    if (selectedLeftValue) {
      const filterPeriod = (period) => {
        let filtered = apiDataset.filter((item) => item.aar === period);
        setFilteredDataset(filtered);
      };
      filterPeriod(selectedLeftValue.value);
    }
    if (!selectedLeftValue && apiDataset) {
      setFilteredDataset(
        apiDataset.filter((item) => {
          if (item.aar) {
            return item.aar.length <= 4;
          }
          return true;
        })
      );
    }
  }, [selectedLeftValue, apiDataset]);

  useEffect(() => {
    if (apiDataset && filter) {
      let filtered = filterDataset(filter, apiDataset, cityIndex);
      setFilteredDataset(filtered);
    }
  }, [apiDataset, cityIndex, filter]);

  useEffect(() => {
    if (leftDropDownOptions && !selectedLeftValue) {
      setSelectedLeftValue(leftDropDownOptions[0]);
    }
  }, [leftDropDownOptions, selectedLeftValue]);

  if (!apiResult) return <p>Mangler data fra SSB</p>;

  if (mergedOptions) {
    return (
      <Block>
        <div className="selectbox">
          {leftDropDown && leftDropDownOptions && (
            <div className="col-lg-6">
              <Select
                options={leftDropDownOptions}
                defaultValue={leftDropDownOptions[0]}
                onChange={(d) => {
                  setSelectedLeftValue(d);
                }}
                value={selectedLeftValue}
              />
            </div>
          )}

          {rightDropDown && (
            <div className="col-lg-6">
              <Select
                options={rightDropDown}
                defaultValue={rightDropDown[0]}
                onChange={(d) => {
                  setSelectedRightValue(d);
                }}
                value={selectedRightValue}
              />
            </div>
          )}
        </div>

        <ReactECharts option={mergedOptions} style={{ marginTop: "20px", height: "700px" }} />
      </Block>
    );
  }

  return null;
};
export default Graph;

const options = JSON.stringify({
  grid: { top: 8, right: 20, bottom: 2, left: 40, containLabel: true },
  // xAxis: {
  //   type: 'category',
  //   data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
  // },
  yAxis: {
    type: "value",
  },
  // series: [
  //   {
  //     data: [820, 932, 901, 934, 1290, 1330, 1320],
  //     type: 'line',
  //     smooth: true,
  //   },
  // ],
  tooltip: {
    trigger: "item",
    formatter: `{c}%`,
  },
});

const parseOptions = (options) => {
  return options.map((option) => Object.assign({}, { label: option, value: option }));
};

const filterDataset = (filter, data, cityIndex) => {
  if (filter === "latestYear") {
    if (!data.some((item) => item.aar)) {
      return data;
    }
    let filtered = data.filter((item) => item.aar.toString().length <= 4);
    let lastestYear = Math.max(...filtered.map((item) => parseInt(item.aar)));
    return data.filter((item) => parseInt(item.aar) === lastestYear);
  }
  if (filter === "cityIndex") {
    return data.filter((item) => item.nr === cityIndex);
  }
  return data;
};
